// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Network$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as ModificationRepoConfig from "./ModificationRepoConfig.bs.js";
import * as NewModificationPayloadMapper from "../entity-mapper/NewModificationPayloadMapper.bs.js";
import * as EditModificationPayloadMapper from "../entity-mapper/EditModificationPayloadMapper.bs.js";
import * as EditModificationPayloadApiModel from "../api-model/EditModificationPayloadApiModel.bs.js";
import * as CreateAbModificationPayloadApiModel from "../api-model/CreateAbModificationPayloadApiModel.bs.js";
import * as ReprioritizeModificationPayloadMapper from "../entity-mapper/ReprioritizeModificationPayloadMapper.bs.js";
import * as CreateSimpleModificationPayloadApiModel from "../api-model/CreateSimpleModificationPayloadApiModel.bs.js";
import * as ReprioritizeModificationPayloadApiModel from "../api-model/ReprioritizeModificationPayloadApiModel.bs.js";

function fetchModifications(campaign_id, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/pricingsystems/ondemand/core_pricing/modifications/campaigns/list?core_pricing_external_id=" + campaign_id);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ModificationRepoConfig.ModificationListResponseConverter.execute, result);
                        });
            });
}

function createModification(payload, iso_code, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/pricingsystems/ondemand/core_pricing/modifications/campaigns/create";
  var match = payload.modification_type;
  var payload_string = match ? JSON.stringify(CreateAbModificationPayloadApiModel.t_encode(NewModificationPayloadMapper.toAbModificationApiPayload(payload, iso_code))) : JSON.stringify(CreateSimpleModificationPayloadApiModel.t_encode(NewModificationPayloadMapper.toSimpleModificationApiPayload(payload, iso_code)));
  return Network$Catalyst.postRequestV2(requestUrl, payload_string, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ModificationRepoConfig.CreateModificationResponseConverter.execute, result);
                        });
            });
}

function editModification(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/pricingsystems/ondemand/core_pricing/modifications/campaigns/update_statuses";
  var payload_string = JSON.stringify(EditModificationPayloadApiModel.t_encode(EditModificationPayloadMapper.getPayload(payload)));
  return Network$Catalyst.postRequestV2(requestUrl, payload_string, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ModificationRepoConfig.EditModificationResponseConverter.execute, result);
                        });
            });
}

function reprioritizeModification(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/pricingsystems/ondemand/core_pricing/modifications/campaigns/reprioritize";
  var payload_string = JSON.stringify(ReprioritizeModificationPayloadApiModel.t_encode(ReprioritizeModificationPayloadMapper.getPayload(payload)));
  return Network$Catalyst.postRequestV2(requestUrl, payload_string, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(ModificationRepoConfig.ReprioritizeModificationResponseConverter.execute, result);
                        });
            });
}

var T = {
  fetchModifications: fetchModifications,
  createModification: createModification,
  editModification: editModification,
  reprioritizeModification: reprioritizeModification
};

export {
  T ,
  
}
/* Config Not a pure module */
